import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var OnetocSvg = function OnetocSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#605E5C",
    fillRule: "evenodd",
    d: "M7.25 22.5h12.5a.75.75 0 0 0 .75-.75V2.25a.75.75 0 0 0-.75-.75H7.25a.75.75 0 0 0-.75.75v19.5c0 .413.337.75.75.75M7 2.25A.25.25 0 0 1 7.25 2h12.5a.25.25 0 0 1 .25.25v19.5a.25.25 0 0 1-.25.25H7.25a.25.25 0 0 1-.25-.25z",
    clipRule: "evenodd",
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9332BF",
    d: "M21.5 14h-1V9.5h1a.5.5 0 0 1 .5.5v3.5a.5.5 0 0 1-.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE4BD5",
    d: "M21.5 8.5h-1V4h1a.5.5 0 0 1 .5.5V8a.5.5 0 0 1-.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7719AA",
    d: "M21.5 19.5h-1V15h1a.5.5 0 0 1 .5.5V19a.5.5 0 0 1-.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.25 22h12.5a.25.25 0 0 0 .25-.25V2.25a.25.25 0 0 0-.25-.25H7.25a.25.25 0 0 0-.25.25v19.5a.25.25 0 0 0 .25.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7719AA",
    d: "M3 18.5h9a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F7F7",
    d: "M4.602 10h1.627l2.88 4.352L9.094 10h1.29v6h-1.56l-2.92-4.278c.024.184.035 4.278.035 4.278H4.602z"
  }));
};
export var Onetoc = function Onetoc(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: OnetocSvg
  }));
};